import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import translations
import enTranslation from './locales/en.json';
import frTranslation from './locales/fr.json';
import frAffiliateUnifiedTranslation from './locales/fr-affiliate-unified.json';
import enAffiliateUnifiedTranslation from './locales/en-affiliate-unified.json';

// Add temporary compatibility for flat keys
// This ensures both t('navigation.affiliate') and t('navigation.affiliate.title') work
const compatibleFrAffiliateTranslation = {
  ...frAffiliateUnifiedTranslation,
  navigation: {
    ...frAffiliateUnifiedTranslation.navigation,
    ...frTranslation.navigation,
    // Add flat key format
    affiliate: frAffiliateUnifiedTranslation.navigation.affiliate
  }
};

// Same compatibility for English translation
const compatibleEnAffiliateTranslation = {
  ...enAffiliateUnifiedTranslation,
  navigation: {
    ...enAffiliateUnifiedTranslation.navigation,
     ...enTranslation.navigation,
    // Add flat key format
    affiliate: enAffiliateUnifiedTranslation.navigation.affiliate
  }
};

// Merge all French translations into a single object
const mergedFrTranslations = {
  ...frTranslation,
  ...compatibleFrAffiliateTranslation
};

// Merge all English translations into a single object
const mergedEnTranslations = {
  ...enTranslation,
  ...compatibleEnAffiliateTranslation
};

const resources = {
  en: {
    translation: mergedEnTranslations
  },
  fr: {
    translation: mergedFrTranslations
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'fr', // default language
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false // react already safes from xss
    }
  });

export default i18n;